var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.5H10C9.45004 0.5 9.00004 0.95 9.00004 1.5V10.5L12 7.5H17C17.55 7.5 18 7.05 18 6.5V1.5C18 0.95 17.55 0.5 17 0.5ZM16.23 12.76L13.69 12.47C13.08 12.4 12.48 12.61 12.05 13.04L10.21 14.88C7.38004 13.44 5.06004 11.13 3.62004 8.29L5.47004 6.44C5.90004 6.01 6.11004 5.41 6.04004 4.8L5.75004 2.28C5.63004 1.27 4.78004 0.51 3.76004 0.51H2.03004C0.900041 0.51 -0.0399593 1.45 0.0300407 2.58C0.560041 11.12 7.39004 17.94 15.92 18.47C17.05 18.54 17.99 17.6 17.99 16.47V14.74C18 13.73 17.24 12.88 16.23 12.76Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.1f92607b849413062b295d96b4a16132.svg";
export { ForwardRef as ReactComponent };